import React, {useCallback, useState} from "react";
import { Formik, Form } from 'formik';
import Yup from '../../../../utils/yup.js';
import { SubmitButton} from "../../../../components/formik/button/SubmitButton.jsx";
import { TextBoxInput } from '../../../../components/formik/inputs/TextBoxInput.jsx';
import { PasswordInput } from '../../../../components/formik/inputs/PasswordInput.jsx';
import {GridContainerFlex} from "../../../../components/layout/GridFlex/GridContainerFlex/GridContainerFlex.jsx";
import {GridItemFlex} from "../../../../components/layout/GridFlex/GridItemFlex/GridItemFlex.jsx";
import {Card} from "../../../../components/composite/Card/Card.jsx";
import {ResetButton} from "../../../../components/formik/button/ResetButton.jsx";
import {PhoneNumberInput} from "../../../../components/formik/inputs/PhoneNumberInput.jsx";
import {CurrencyInput} from "../../../../components/formik/inputs/CurrencyInput.jsx";
import {DecimalInput} from "../../../../components/formik/inputs/DecimalInput.jsx";
import {IntegerInput} from "../../../../components/formik/inputs/IntegerInput.jsx";
import {PercentageInput} from "../../../../components/formik/inputs/PercentageInput.jsx";
import {CodeSnip} from "../../../../components/base/typography/CodeSnip.jsx";
import {ToggleInput} from "../../../../components/formik/inputs/ToggleInput.jsx";
import {TextAreaInput} from "../../../../components/formik/inputs/TextAreaInput.jsx";
import {ZipCodeInput} from "../../../../components/formik/inputs/ZipCodeInput.jsx";
import {DatePickerInput} from "../../../../components/formik/inputs/DatePickerInput.jsx";
import {DateTimePickerInput} from "../../../../components/formik/inputs/DateTimePickerInput.jsx";
import {TimePicker} from "../../../../components/formik/inputs/TimePicker.jsx";
import {DateRangePickerInput} from "../../../../components/formik/inputs/DateRangePickerInput.jsx";
import {PrimitiveDropdownListInput} from "../../../../components/formik/inputs/PrimitiveDropdownListInput.jsx";
import {DropdownListInput} from "../../../../components/formik/inputs/DropdownListInput.jsx";
import {PrimitiveComboBoxInput} from "../../../../components/formik/inputs/PrimitiveComboBoxInput.jsx";
import {ComboBoxInput} from "../../../../components/formik/inputs/ComboBoxInput.jsx";
import {PrimitiveMultiSelectInput} from "../../../../components/formik/inputs/PrimitiveMultiSelectInput.jsx";
import {MultiSelectInput} from "../../../../components/formik/inputs/MultiSelectInput.jsx";
import {StarRatingInput} from "../../../../components/formik/inputs/StarRatingInput.jsx";
import {ShowcaseLayout} from "../../layout/ShowcaseLayout.jsx";



export const TestForm = () => {
    const [submittedValues, setSubmittedValues] = useState();

    const handleSubmit = async (values) => {
        setSubmittedValues(values);
    };

    const handleReset = async () => {
        setSubmittedValues(null);
    }

    const initialValues = {
        textField: '',
        someNestedObj: {
            nestedValue: ''
        },
        textFieldWithCustomHandlers: '',
        textAreaField: '',
        passwordField: '',
        decimalField: '',
        phoneField: '',
        currencyField: '',
        integerField: '',
        percentageField: '',
        toggleField: false,
        zipCodeField: '',
        datePickerField: null,
        dateTimePickerField: null,
        timePickerField: null,
        dateRangePickerField: null,
        primitiveDropdownListField: null,
        dropdownListField: null,
        primitiveComboBoxField: null,
        comboBoxField: null,
        primitiveMultiSelectField: null,
        multiSelectField: null,
        starRatingField: null,

    };
    const validationSchema = useCallback(() => Yup.object({
        textField: Yup.string().required('Required'),

    }),[]);

    return (
        <ShowcaseLayout>
            <Card title={"Test Form"}>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={async (values, { setSubmitting }) => {
                        try {
                            setSubmitting(true)
                            await handleSubmit(values);
                        } catch (e) {
                            console.error(e);
                        } finally {
                            setSubmitting(false);
                        }
                    }}
                >
                    <Form>
                        <GridContainerFlex
                            alignItems={"end"}
                            gap={"20px"}
                        >
                            <GridItemFlex xs={12} sm={6} md={4} lg={3}>
                                <TextBoxInput
                                    name="textField"
                                    label="Text field"
                                    required={true}
                                />
                            </GridItemFlex>
                            <GridItemFlex xs={12} sm={6} md={4} lg={3}>
                                <TextBoxInput
                                    name="someNestedObj.nestedValue"
                                    label="Text field (nested)"
                                />
                            </GridItemFlex>
                            <GridItemFlex xs={12} sm={6} md={4} lg={3}>
                                <TextBoxInput
                                    name="textFieldWithCustomHandlers"
                                    disabled={(context) => {
                                        // Example of a custom disabled handler.
                                        if(context.values["textField"] === "123") return true
                                    }}
                                    onChange={async (e, context) => {
                                        // Example of a custom onChange handler.
                                        await context.setFieldValue("textField", '');
                                        await context.setFieldValue("textFieldWithCustomHandlers", context.newValue);
                                    }}
                                    label="Text field (with custom handlers)"
                                />
                            </GridItemFlex>
                            <GridItemFlex xs={12} sm={6} md={4} lg={3}>
                                <TextAreaInput
                                    name="textAreaField"
                                    label="Text Area field"
                                />
                            </GridItemFlex>
                            <GridItemFlex xs={12} sm={6} md={4} lg={3}>
                                <PasswordInput
                                    name="passwordField"
                                    label="Password field"
                                />
                            </GridItemFlex>
                            <GridItemFlex xs={12} sm={6} md={4} lg={3}>
                                <DecimalInput
                                    name="decimalField"
                                    label="Decimal field"
                                />
                            </GridItemFlex>
                            <GridItemFlex xs={12} sm={6} md={4} lg={3}>
                                <PhoneNumberInput
                                    name="phoneField"
                                    label="Phone number field"
                                />
                            </GridItemFlex>
                            <GridItemFlex xs={12} sm={6} md={4} lg={3}>
                                <CurrencyInput
                                    name="currencyField"
                                    label="Currency (US) field"
                                />
                            </GridItemFlex>
                            <GridItemFlex xs={12} sm={6} md={4} lg={3}>
                                <IntegerInput
                                    name="integerField"
                                    label="Integer field"
                                />
                            </GridItemFlex>
                            <GridItemFlex xs={12} sm={6} md={4} lg={3}>
                                <PercentageInput
                                    name="percentageField"
                                    label="percentage field"
                                />
                            </GridItemFlex>
                            <GridItemFlex xs={12} sm={6} md={4} lg={3}>
                                <ToggleInput
                                    name="toggleField"
                                    label="Toggle field"
                                />
                            </GridItemFlex>
                            <GridItemFlex xs={12} sm={6} md={4} lg={3}>
                                <ZipCodeInput
                                    name="zipCodeField"
                                    label="Zip Code field"
                                />
                            </GridItemFlex>
                            <GridItemFlex xs={12} sm={6} md={4} lg={3}>
                                <DatePickerInput
                                    name="datePickerField"
                                    label="Date Picker field"
                                />
                            </GridItemFlex>
                            <GridItemFlex xs={12} sm={6} md={4} lg={3}>
                                <DateTimePickerInput
                                    name="dateTimePickerField"
                                    label="Date Time Picker field"
                                />
                            </GridItemFlex>
                            <GridItemFlex xs={12} sm={6} md={4} lg={3}>
                                <TimePicker
                                    name="timePickerField"
                                    label="Time Picker field"
                                />
                            </GridItemFlex>
                            <GridItemFlex xs={12} sm={6} md={4} lg={3}>
                                <DateRangePickerInput
                                    name="dateRangePickerField"
                                    label="Date Range Picker field"
                                />
                            </GridItemFlex>
                            <GridItemFlex xs={12} sm={6} md={4} lg={3}>
                                <PrimitiveDropdownListInput
                                    name={"primitiveDropdownListField"}
                                    label={"Primitive Dropdown field"}
                                    data={["Option 1", "Option 2", "Option 3"]}
                                />
                            </GridItemFlex>
                            <GridItemFlex xs={12} sm={6} md={4} lg={3}>
                                <DropdownListInput
                                    name={"dropdownListField"}
                                    label={"Dropdown field"}
                                    data={[{id: 1, text: "Option 1"}, {id: 2, text: "Option 2"}, {id: 3, text: "Option 3"}]}
                                />
                            </GridItemFlex>
                            <GridItemFlex xs={12} sm={6} md={4} lg={3}>
                                <PrimitiveComboBoxInput
                                    name={"primitiveComboBoxField"}
                                    label={"Primitive Combo Box field"}
                                    data={["Option 1", "Option 2", "Option 3"]}
                                />
                            </GridItemFlex>
                            <GridItemFlex xs={12} sm={6} md={4} lg={3}>
                                <ComboBoxInput
                                    name={"comboBoxField"}
                                    label={"Combo Box field"}
                                    data={[{id: 1, text: "Option 1"}, {id: 2, text: "Option 2"}, {id: 3, text: "Option 3"}]}
                                />
                            </GridItemFlex>
                            <GridItemFlex xs={12} sm={6} md={4} lg={3}>
                                <PrimitiveMultiSelectInput
                                    name={"primitiveMultiSelectField"}
                                    label={"Primitive Multi Select field"}
                                    data={["Option 1", "Option 2", "Option 3"]}
                                />
                            </GridItemFlex>
                            <GridItemFlex xs={12} sm={6} md={4} lg={3}>
                                <MultiSelectInput
                                    name={"multiSelectField"}
                                    label={"Multi Select field"}
                                    data={[{id: 1, text: "Option 1"}, {id: 2, text: "Option 2"}, {id: 3, text: "Option 3"}]}
                                />
                            </GridItemFlex>
                            <GridItemFlex xs={12} sm={6} md={4} lg={3}>
                                <StarRatingInput
                                    name={"starRatingField"}
                                    label={"Star Rating field"}
                                />
                            </GridItemFlex>

                            <GridItemFlex>
                                <SubmitButton >
                                    Submit
                                </SubmitButton>
                            </GridItemFlex>
                            <GridItemFlex>
                                <ResetButton onReset={handleReset}>
                                    Reset
                                </ResetButton>
                            </GridItemFlex>
                        </GridContainerFlex>
                    </Form>
                </Formik>
                {submittedValues &&
                    <CodeSnip code={`${JSON.stringify(submittedValues, null, 2)}`} />
                }
            </Card>
        </ShowcaseLayout>
    );
};